import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({ standalone: false,
  selector: "search-bar",
  templateUrl: "./search-bar.component.html",
  styleUrls: ["./search-bar.component.scss"],
})
export class SearchBarComponent implements OnInit {
  @Input() placeholder: string = "";
  @Input() items: any[] = [];
  @Input() loadingSearch: boolean = false;
  @Input() onKeyPress: boolean = true;
  @Input() excuteOnEnter: boolean = true;
  @Input() searchQuery: string = "";
  @Input() displayProperty: string = "";
  @Input() isOpen: boolean = false;
  @Input() icon: string = "icon-search";

  @Output() searchQueryEmit: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() cleanSearchEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() focusOut: EventEmitter<any> = new EventEmitter<any>();
  @Output() dropdownOpenChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() enterPressed: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild("searchInput") searchInput: ElementRef;

  public showItems: boolean = false;
  public focus: boolean = false;
  public id: any = this.generateUUID();

  constructor(private elRef: ElementRef, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (this.isOpen && !this.elRef.nativeElement.contains(event.target)) {
      this.focus = false;
      this.showItems = false;
      this.dropdownOpenChange.emit(this.showItems);
      this.focusOut.emit();
    }
  }

  selectSearch() {
    this.searchQueryEmit.emit(this.searchQuery);
  }

  onKeyDown(event: any) {
    if (event.key === "Enter" && this.excuteOnEnter) {
      this.searchQueryEmit.emit(this.searchQuery);
      this.enterPressed.emit(this.searchQuery); 
    }
  }

  showCourseToggle(): void {
    this.showItems = !this.showItems;
    this.dropdownOpenChange.emit(this.showItems);
  }

  onSearchQuery(searchText) {
    if (this.onKeyPress || searchText === "") {
      this.searchQueryEmit.emit(searchText);
    }
  }

  onItemSelected(item: any): void {
    this.itemSelected.emit(item);
  }

  onButtonClick(): void {
    this.focusInput();
  }

  onCleanSearch() {
    if (this.searchQuery === "") {
      this.onBlur();
      return;
    }

    this.searchQuery = "";
    this.cleanSearchEmit.emit();
    this.focusInput();
  }

  onFocus() {
    this.focus = true;
    this.focusOut.emit();
  }

  onBlur() {
    this.focus = false;
    this.showItems = false;
    this.dropdownOpenChange.emit(this.showItems);
    let searchInput = document.getElementById("searchInput-" + this.id);
    searchInput?.blur();
  }

  focusInput() {
    let searchInput = document.getElementById("searchInput-" + this.id);
    searchInput.focus();
    this.showItems = true;
    this.dropdownOpenChange.emit(this.showItems);
  }

  onInputChange(event: any) {
    console.log(event.target.value);
  }

  generateUUID(): string {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 =
      (typeof performance !== "undefined" &&
        performance.now &&
        performance.now() * 1000) ||
      0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
  }

  getHighlightedText(item: any): SafeHtml {
    let text = item?.highlights?.name ?? item?.name;

    if (Array.isArray(text)) {
      text = text[0];
    }

    const decoded = this.decodeHtml(text);

    return this.sanitizer.bypassSecurityTrustHtml(decoded);
  }

  private decodeHtml(html: string): string {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
}
